import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Divider,
  Stack,
  styled,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { format } from "date-fns";

const StyledModalBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: "#262626",
  borderRadius: "10px",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.5)",
  padding: theme.spacing(4),
  border: "none",
  outline: "none",
  [theme.breakpoints.down("sm")]: {
    width: "75%",
  },
}));

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) {
    return "$ 0.00";
  }
  return Number(amount).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const truncateAddress = (address, startChars = 6, endChars = 4) => {
  if (!address || address.length <= startChars + endChars) {
    return address;
  }
  return `${address.substring(0, startChars)}...${address.substring(
    address.length - endChars
  )}`;
};

const TransactionDetailRow = ({ label, value }) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    sx={{
      flexDirection: { sm: "row" },
      alignItems: { sm: "center" },
    }}
  >
    <Typography variant="body1" fontWeight="bold" color="text.primary">
      {label}:
    </Typography>
    <Typography variant="body1" color="text.secondary">
      {value}
    </Typography>
  </Stack>
);

const TransactionModal = ({ open, handleClose, transaction }) => {
  const [copied, setCopied] = useState(false);

  if (!transaction) {
    return null;
  }

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Error al copiar: ", err);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="transaction-modal-title"
      aria-describedby="transaction-modal-description"
    >
      <StyledModalBox>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            id="transaction-modal-title"
            variant="h5"
            component="h2"
            color="text.primary"
          >
            Detalles de la Transacción
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon sx={{ color: "text.secondary" }} />
          </IconButton>
        </Stack>
        <Divider sx={{ my: 2 }} />
        <Stack spacing={2}>
          <TransactionDetailRow
            label="Nombre"
            value={transaction.property.name}
          />
          <TransactionDetailRow
            label="Cantidad de Tokens"
            value={`${transaction.amountToken} ${transaction.property.symbol}`}
          />

          <TransactionDetailRow
            label="Valor Total (USDT)"
            value={formatCurrency(transaction.toAmount)}
          />
          <TransactionDetailRow label="Clabe" value={transaction.clabe} />
          <TransactionDetailRow
            label="Concepto"
            value={transaction.reference}
          />
          <TransactionDetailRow
            label="Tipo de pago"
            value={transaction.paymentType}
          />
          <TransactionDetailRow
            label="Expira"
            value={format(transaction.expirationDate, "ddMMyy")}
          />
          <TransactionDetailRow
            label="Activo"
            value={transaction.property.name}
          />
          <TransactionDetailRow
            label="Transferencia Electrónica de Fondos"
            value={transaction.bankName}
          />

          {/*   {['Depósito', 'Retiro'].includes(transaction.type) && (
            <Stack 
              direction='row'
              justifyContent="space-between" 
              alignItems='center'
              spacing={0}
            >
              <Typography variant="body1" fontWeight="bold" color="text.primary">Wallet:</Typography>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="body1" color="text.secondary">
                  {truncateAddress(transaction.walletAddress)}
                </Typography>
                <Tooltip title={copied ? "¡Copiado!" : "Copiar dirección"} placement="top" arrow>
                  <IconButton 
                    onClick={() => handleCopy(transaction.walletAddress)} 
                    size="small"
                    sx={{ color: copied ? '#33ab9f' : 'text.secondary' }}
                  >
                    {copied ? <CheckCircleIcon /> : <ContentCopyIcon />}
                  </IconButton>
                </Tooltip>
              </Stack>
            </Stack>
          )} */}
          {/*  {transaction.type === 'Compra' && (
            <TransactionDetailRow label="Precio por Token" value={formatCurrency(transaction.pricePerToken)} />
          )} */}
        </Stack>
      </StyledModalBox>
    </Modal>
  );
};

export default TransactionModal;
